export const stickerPrinterService = {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  setDevice: (deviceId: string, name: string) => {
    // Actually device preference is handled in workstationPreferenceService
    // This is just a stub for consistency with other device services if needed
  },
};
